export const seoConfig = {
  home: {
    title: 'AI ChatBot Software for Sales: Close More Deals with Automation',
    description: 'Increase sales and close deals faster with AI ChatBot software. Automate responses, capture leads, and convert visitors into customers 24/7. Try it today!',
    keywords: 'AI Chatbot software, Sales Chatbot Software',
    ogImage: 'assets/legittmateAI-xyG3FGeC.svg',
  },
  aboutus: {
    title: 'About Us: AI ChatBot Experts Driving Business Growth',
    description: 'We specialize in AI ChatBot software that enhances customer interactions, automates tasks, and helps businesses scale faster. Learn more about our journey.',
    keywords: 'about us,',
    ogImage: 'assets/legittmateAI-xyG3FGeC.svg',
    type: 'article' as const,
    publishedTime: '2024-01-01T00:00:00Z',
  },
  privacy: {
    title: 'Privacy Policy: How We Protect Your Data & Security',
    description: 'Read our Privacy Policy to learn how we collect, use, and protect your data. We prioritize security and transparency in our AI ChatBot software.',
    keywords: 'privacy policy',
    type: 'article' as const,
    publishedTime: '2024-01-01T00:00:00Z',
    modifiedTime: new Date().toISOString(),
  },
  terms: {
    title: 'Terms and Conditions: Use of Our AI ChatBot Software',
    description: 'Review our Terms and Conditions to understand the guidelines for using our AI ChatBot software, services, and features. Stay informed and compliant.',
    keywords: 'Terms and Condition',
    type: 'article' as const,
    publishedTime: '2024-01-01T00:00:00Z',
    modifiedTime: new Date().toISOString(),
  },
  pricing: {
    title: 'AI Chatbot Software Pricing | Scalable Plans for All Businesses',
    description: 'Discover flexible AI chatbot software pricing plans tailored to your business needs. Get affordable, scalable, and feature-rich chatbot solutions to enhance customer engagement today!',
    keywords: 'AI Chatbot Software Pricing ',
    type: 'article' as const,
    publishedTime: '2024-01-01T00:00:00Z',
    modifiedTime: new Date().toISOString(),
  },
  demo: {
    title: 'Experience AI-Powered Chatbots – Book a Demo',
    description: 'See AI Chatbots in Action – Experience how AI-powered chatbots automate customer support, boost engagement, and enhance efficiency. Book a free demo toda',
    keywords: 'AI Chatbot Software Demo',
    type: 'article' as const,
    publishedTime: '2024-01-01T00:00:00Z',
    modifiedTime: new Date().toISOString(),
  },
  demoSuccess: {
    title: "Demo Request Received | LegittmateAI",
    description: "Thank you for scheduling a demo with LegittmateAI. We'll be in touch shortly.",
    // other SEO properties
  }
}; 